import { DisasterTranslator } from "@/js/translators/disasterTranslator";

export default {
  methods: {
    getLatestDisaster: function(disasters) {
      if (!disasters || disasters.length < 1) {
        return null;
      }
      return DisasterTranslator.sortByDisasterNo(disasters, true)[0];
    },
    defaultDisaster(disaster) {
      if (!disaster) {
        disaster = {
          disaster_no: "",
          disaster_name: "",
          emerg_cls: ""
        };
      }
      return disaster;
    }
  }
};
